<template>
    <div :class="{dashboard: this.$route.name !== 'serviceLogConfig',
                admin_page: this.$route.name == 'serviceLogConfig'}" class="wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="pl-3 mb-3">

            <b-form-checkbox v-if="question_guid" v-model="takeServiceLogFromPlace">
                <span>{{ translate('sldTakeFromPlace') }}</span>
            </b-form-checkbox>
			<b-form-checkbox v-model="showServiceLogConfig">
				<span>{{ translate('enableServiceLog') }}</span>
			</b-form-checkbox>
        </div>
		<div class="secLevel__wrapper">
			<div class="serviceLog__wrapper">
				<div class="serviceLog" v-if="showServiceLogConfig">
					<secondLevelRectanglesContent :blockValues="serviceLogValues" :fieldsConfig="getServiceLogFieldConfig()" :config = this.serviceLogConfig></secondLevelRectanglesContent>
				</div>
			</div>
		</div>
		<div class="saveBtn__wrapper">
			<div class="saveBtn" @click="saveServiceLogConfigClick">
				{{ translate('Save') }}
			</div>
		</div>
	</div>
</template>

<script>
    import customModalDialog from "../widgets/customModalDialog";
    import secondLevelRectanglesContent from "./secondLevelRectanglesContent";
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import errorMixin from "@/mixins/errorMixin";
    import 'verte/dist/verte.css';
    export default {
        mixins: [errorMixin],
        name: "ServiceLogConfig",
        components: {
            customModalDialog,
			secondLevelRectanglesContent
        },
        data() {
            return {
				showServiceLogConfig: false,
                place_guid: null,
                organization_guid: null,
                question_guid: null,
				serviceLogFieldsConfig: {
					showMainCheckbox: false,
					title: this.translate('serviceLog'),
                    showForce: true,
					showRequirePin: true,
					showCommentAlways: true,
					showServiceLogPopup: true,
					showPlacementEdit: true,
					showMaxCountSelectedItems: false,
					showOverrideBasicBlocks: false,
					showOverrideBasicSettings: false,
					blocksHaveIcons: false,
				},
				serviceLogConfig: {
					title: '',
					show: true,
					force: false,
					requiredPin: false,
					serviceInfoPopup: false,
					placementEdit: false,
					background: "#8080804C",
					showCommentAlways: false,
					overrideBasicSettings: true,
					overrideBasicBlocks: true,
                    overrideSubtitle: false,
                    subtitle: '',
                    overrideAutoCameraOpenFlow: false,
                    auto_open_camera: false,
					blocks: [
						{
							text: '',
							value: '',
                            overrideAutoCameraOpenFlow: false,
                            auto_open_camera: false,
						},
					],
				},

				serviceLogValues: [
					{
						text: 'Cleaned',
						value: 'Cleaned'
					},
					{
						text: "Pumped",
						value: 'Pumped'
					},
					{
						text: "Filled Water",
						value: 'Filled Water'
					},
					{
						text: "Unable to Service",
						value: 'Unable to Service'
					},
					{
						text: "Repair Service",
						value: 'Repair Service'
					},
					{
						text: "Installed",
						value: 'Installed'
					},
				],
                customModalSettings: {},
				takeServiceLogFromPlace: false,


            }
        },
        watch: {
			takeServiceLogFromPlace(newValue) {
                if(newValue) this.showServiceLogConfig = false
            },
            showServiceLogConfig(newValue) {
                if(newValue) {
                  this.takeServiceLogFromPlace = false
                  this.serviceLogConfig.show = true
                  this.serviceLogConfig.overrideBasicBlocks = true
                  this.serviceLogConfig.overrideBasicSettings = true
                }
            }
        },
        props: ['admin', 'showConfigPopup'],
        mounted() {
            this.getParams()
			this.fetchServiceLogConfigAction()
        },

        methods: {
            ...mapActions({
				fetchServiceLogConfig: 'place/fetchServiceLogConfig',
				saveServiceLogConfig: 'place/saveServiceLogConfig',
				fetchServiceLogConfigForQuestion: 'question/fetchServiceLogConfigForQuestion',
				saveServiceLogConfigForQuestion: 'question/saveServiceLogConfigForQuestion',

            }),
            ...mapMutations({
                setProgressBarTag: 'setProgressBarTag'
            }),

			async fetchServiceLogConfigAction() {
				try {
					this.setProgressBarTag({
						show: true,
						tag: 'fetch_serviceLogConfig'
					})
					let response

					if(this.question_guid) {
						response = await this.fetchServiceLogConfigForQuestion({
							org_guid: this.organization_guid,
							place_guid: this.place_guid,
							question_guid: this.question_guid
						});
					} else {
						response = await this.fetchServiceLogConfig({
							org_guid: this.organization_guid,
							place_guid: this.place_guid
						});
					}
					if (response.success) {
						response.service_log_config !== null && response.service_log_config.length == 0 ? this.takeServiceLogFromPlace = true : this.showServiceLogConfig = true

						this.showServiceLogConfig = response.service_log_config !== null
						if(this.showConfigPopup && response.service_log_config == null) {
							this.customModalSettings = {
								message: this.translate('configMissingMsg'),
								onOkHandler: this.showDefaultConfig,
								onCancelHandler: this.backToPreviousPageAction,
								showCancelButton: true,
								okButtonText: this.translate('yes'),
								cancelButtonText: this.translate('no'),
							}
						}
						this.checkServiceLogConfig(this.serviceLogConfig, response.service_log_config)
					}
				} catch (error) {
					this.showErrorModal(error.data.error.message)
				} finally {
					this.setProgressBarTag({
						show: false,
						tag: 'fetch_serviceLogConfig'
					})
				}
			},
			checkServiceLogConfig(block, response) {
				if (response == null || response.length == 0) {
					block.show = false
					block.overrideBasicSettings = false
					block.overrideBasicBlocks = false
				} else {
					block.show = true
					if (response.title != null || response.background != null || response.required_pin != null || response.service_info_popup != null || response.placement_edit != null) {
						block.title = response.title == null ? "" : response.title
						block.background = response.background == null ? this.serviceLogConfig.background : response.background
						block.force = response.force == null ? false : response.force
						block.requiredPin = response.require_pin == null ? false : response.require_pin
						block.serviceInfoPopup = response.show_service_info_popup == null ? false : response.show_service_info_popup
						block.placementEdit = response.show_placement_edit == null ? false : response.show_placement_edit
						block.showCommentAlways = response.show_comment_always == null ? false : response.show_comment_always
                        if (response.subtitle == null) {
                            block.subtitle = null
                            block.overrideSubtitle = false
                        } else {
                            block.subtitle = response.subtitle
                            block.overrideSubtitle = true
                        }
                        if (response.auto_open_camera == null) {
                            block.auto_open_camera = false
                            block.overrideAutoCameraOpenFlow = false
                        } else {
                            block.auto_open_camera = response.auto_open_camera
                            block.overrideAutoCameraOpenFlow = true
                        }
					}
                    if (response.blocks != null) {
                        let blocks = []
                        response.blocks.forEach((element) => {
                            let block = {
                                text: element.text,
                                value: element.text,
                                overrideAutoCameraOpenFlow: element.auto_open_camera != null,
                                auto_open_camera: element.auto_open_camera != null ? element.auto_open_camera : false,
                            }
                            blocks.push(block)
                        })
                        block.blocks = blocks
                    } else {
                        block.blocks = []
                    }
				}
			},
            backToPreviousPageAction() {
              this.$router.go(-1);
            },

			saveServiceLogConfigClick() {
				this.saveServiceLogConfigAction()
			},
			async saveServiceLogConfigAction() {
				let data
				if(this.showServiceLogConfig) {
					this.serviceLogConfig.show = true
					data = this.saveServiceLogBlockAction(this.serviceLogConfig)
				} else if(this.takeServiceLogFromPlace) {
					data = []
				} else {
					data = null
				}
				try {
					this.setProgressBarTag({
						show: true,
						tag: 'save_serviceLogConfig'
					})
					let response
					if(this.question_guid) {
						response = await this.saveServiceLogConfigForQuestion({
							org_guid: this.organization_guid,
							place_guid: this.place_guid,
							question_guid: this.question_guid,
							service_log_config: data
						});
					} else {
						response = await this.saveServiceLogConfig({
							org_guid: this.organization_guid,
							place_guid: this.place_guid,
							service_log_config: data
						});
					}
					if (response.success) {
						this.showErrorModal('Saved')
					}
				} catch (error) {
					this.showErrorModal(error.data.error.message)
				} finally {
					this.setProgressBarTag({
						show: false,
						tag: 'save_serviceLogConfig'
					})
				}
			},
			saveServiceLogBlockAction(config) {
				if(!config.show) return null
				let data = {}
				data.title = config.title
				data.background = config.background
				data.show_comment_always = config.showCommentAlways
				data.show_service_info_popup = config.serviceInfoPopup
				data.show_placement_edit = config.placementEdit
				data.force = config.force
				data.require_pin = config.requiredPin
                if(config.overrideSubtitle) {
                    data.subtitle = config.subtitle
                }
                if(config.overrideAutoCameraOpenFlow) {
                    data.auto_open_camera = config.auto_open_camera
                }

                let blocks = []
                config.blocks.forEach((element) => {
                    let block = {
                        icon: element.icon,
                        text: element.text,
                        value: element.text,
                    }
                    if(element.overrideAutoCameraOpenFlow) {
                        block.auto_open_camera = element.auto_open_camera
                    }
                    blocks.push(block)
                })
                data.blocks = blocks
				return data
			},

            getParams() {
              this.place_guid = this.$route.params.uid
              this.organization_guid = this.$route.params.orgUid
              this.question_guid = this.$route.params.questionUid
            },
            showDefaultConfig() {
              this.showServiceLogConfig = true
              this.serviceLogConfig.show = true
              this.serviceLogConfig.overrideBasicSettings = true
              this.serviceLogConfig.overrideBasicBlocks = true
            },
			getServiceLogFieldConfig() {
				return this.serviceLogFieldsConfig
			}
        }
    }
</script>


<style scoped>
    .placeId_input__wrapper .md-field {
        max-width: 500px !important;
    }
    .wrapper.dashboard {
        margin-top: 25px;
    }
    .wrapper.admin_page {
        max-height: calc(100vh - 62px);
        overflow: scroll;
    }
    .wrapper::-webkit-scrollbar {
      display: none;
    }

    .block-image img {
        width: auto;
    }
    .block-input:first-child {
        margin-right: 20px !important;
    }
    .draggable-items {
        margin-top: 15px;
    }
    .md-menu-content.md-select-menu .md-list {
        display: flex !important;
        flex-direction: row !important;
    }
    .md-list-item-text div {
        display: flex !important;
        flex-direction: column;
        align-items: center;
    }
    .md-list-item-text img {
        height: 50px;
        width: 50px;
    }
    .trash-icon img {
        width: 13px;
        height: 13px;
    }
    .block-icons img {
        width: 35px;
        height: 35px;
    }
    .add_block_btn {
        cursor: pointer;
        display: flex;
        justify-content: center;
        margin-top: 15px;
        align-items: center;
    }
    .saveBtn__wrapper {
        margin-bottom: 250px;
        display: flex;
        justify-content: start;
    }
    .saveBtn {
        cursor: pointer;
        background-color: #3F405C;
        color: white;
        padding: 15px;
        border-radius: 6px;
    }
	.secLevel__wrapper {
		display: flex;
		justify-content: space-between;
	}
	.serviceLog__wrapper {
		max-width: 450px;
		width: 100%;
	}

</style>
